__webpack_require__.p = "https://cdn.n-tv.de/sport/0.66.4/_next/";